import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Existe tratamiento para la depresión sin más medicación?",
    answer:
      "Sí. La TMS está autorizada por la FDA para la depresión que no ha respondido a medicación. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177). SPRAVATO® está aprobado por la FDA para la depresión resistente al tratamiento. Actúan por mecanismos distintos a los antidepresivos orales.",
  },
  {
    question: "¿Puedo dejar de tomar antidepresivos y probar otra cosa?",
    answer:
      "Nunca suspenda la medicación abruptamente sin supervisión. Hable con su médico sobre una reducción gradual y qué probar después. La TMS, SAINT® y SPRAVATO® son opciones que su psiquiatra puede considerar.",
  },
];

export const esNoMoreMedication = makeEsArticle({
  slug: "depression-treatment-without-another-medication",
  title: "Tratamiento para la depresión sin otra medicación | Neuro Wellness",
  description:
    "Opciones de tratamiento para la depresión sin añadir otro antidepresivo: TMS, SAINT® y SPRAVATO® para la depresión resistente al tratamiento.",
  h1: "Tratamiento para la depresión sin otra medicación",
  breadcrumbLabel: "Sin otra medicación",
  shortAnswer:
    "Si no quiere añadir otro antidepresivo, existen opciones que actúan por mecanismos distintos a la medicación oral. La TMS está autorizada por la FDA para la depresión que no ha respondido a medicación. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177). SPRAVATO® está aprobado por la FDA para la depresión resistente al tratamiento. La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "Existen opciones sin añadir otro antidepresivo.",
    "La TMS está autorizada por la FDA para depresión sin respuesta a medicación.",
    "SAINT® es TMS acelerada de cinco días (K220177).",
    "SPRAVATO® está aprobado por la FDA para la depresión resistente.",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "Opciones sin más medicación oral",
      paragraphs: [
        "La TMS y SAINT® TMS acelerada usan estimulación magnética, no medicación oral. SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. SPRAVATO® actúa mediante receptores NMDA, un mecanismo distinto.",
      ],
    },
    {
      heading: "El siguiente paso",
      paragraphs: [
        "Una evaluación psiquiátrica puede determinar si estas opciones son apropiadas. Nunca suspenda la medicación abruptamente sin supervisión. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
